import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { Container, Col, Row } from 'reactstrap';
import PatientProvider from '../../../containers/Providers/Patient';
import QuestionnaireResponseReport from '../../../containers/Report/Questionnaire';

const QuestionnaireView = ({
  match,
}: RouteComponentProps<{
  organizationId: string;
  patientId: string;
  questionnaireResponseId: string;
}>) => {
  const { patientId, questionnaireResponseId } = match.params;
  return (
    <PatientProvider patientId={patientId}>
      <Container fluid className="mt-3">
        <Row>
          <Col>
            <QuestionnaireResponseReport
              questionnaireResponseId={questionnaireResponseId}
            />
          </Col>
        </Row>
      </Container>
    </PatientProvider>
  );
};
export default withRouter(QuestionnaireView);
